export default __webpack_public_path__ + "static/media/Apptt-Cake-logo-white.e2dd9b35.png";